import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3302eee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "announcement-card" }
const _hoisted_2 = {
  key: 0,
  class: "verifiedBtn announcement-card__new"
}
const _hoisted_3 = { class: "announcement-card__img" }
const _hoisted_4 = { class: "announcement-card__info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Адрес:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Цена:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "id:", -1))
const _hoisted_8 = { class: "announcement-card__actions" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = { class: "items-in-line space-between announcement-card__actions-icons" }
const _hoisted_11 = { class: "items-in-line scale gap--3" }
const _hoisted_12 = { class: "items-in-line gap--3" }
const _hoisted_13 = { class: "items-in-line gap--3" }
const _hoisted_14 = { class: "items-in-line gap--5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gradient-color" }, "Чат:", -1))
const _hoisted_16 = { class: "error-color xxs-font-size" }
const _hoisted_17 = { class: "third-color" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "none-Mobile" }, "Осталось", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "announcement-card__ellipsis" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ellipsis" }, "...", -1))
const _hoisted_24 = { class: "items-in-column gap--0 announcement-card__popup-menu" }

import { SmallOfferCardType } from '@/types/MainPageTypes';
import { computed, ref, Ref } from 'vue';
import { DeleteCategoryModalType, TypesMyAdsType } from '@/types';
import { DeleteDeveloperModal } from '@/components/ProfileComponents';
import { useDevelopersStore } from '@/store/modules/developers';
import { createDecliningLabel } from '@/utils/Common/Common';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementCard',
  props: {
    card: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const successMessage: Ref<string | undefined> = ref(undefined);
const deleteCategoryModalData: Ref<DeleteCategoryModalType> = ref({
  show: false,
  id: undefined,
});
const showDeleteCategoryModal = (id: number) => {
  deleteCategoryModalData.value = {
    show: true,
    id: id,
  };
};

const closeDeleteCategoryModal = () => {
  deleteCategoryModalData.value = {
    show: false,
    id: undefined,
  };
};
const router = useRouter();
const editCard = () => {
  useDevelopersStore().clearMyAnnouncement();
  router.push({ name: 'updateOfferCard', query: { id: props.card.id } });
};
const addToArchive = () => {
  useDevelopersStore().addToArchive(props.card);
};
const removeFromArchive = () => {
  useDevelopersStore().removeFromArchive(props.card);
};
const prolongAd = async () => {
  await useDevelopersStore()
    .prolongAnnouncement(props.card.id)
    .then(() => {
      successMessage.value = 'Объявление пролонгировано';
    });
};

const activeDays = computed((): number => {
  const date1 = new Date();
  const date2 = new Date(props.card.activeTo);

  return Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_popup = _resolveComponent("base-popup")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.card.isNew)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Новое"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type === 'active' ? 'router-link' : 'span'), {
            to: { name: 'offerCard', params: { url: _ctx.card.linkUrl } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_image, {
                name: String(_ctx.card.id),
                src: _ctx.card.img,
                borderRadius: "",
                cover: "",
                height: "100%",
                width: "100%"
              }, null, 8, ["name", "src"])
            ]),
            _: 1
          }, 8, ["to"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.card.address || '-'), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.card.price ? _ctx.card.price?.toLocaleString() : '-') + " ₽ ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.card.id), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_base_icon, {
                height: "20",
                name: "visibility"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.card.views), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_base_icon, {
                height: "20",
                name: "favorite"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.card.favorites), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_icon, {
                height: "20",
                name: "playlist_add_check"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.card.comparisons), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.card.chats), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.type === 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(activeDays.value) + " " + _toDisplayString(_unref(createDecliningLabel)(activeDays.value, ['День', 'Дня', 'Дней'])), 1)
                ]))
              : (_ctx.type === 'drafts')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Не опубликовано"))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, "Закрыто"))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_base_popup, null, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "announcement-card__popup-menu-item",
                  onClick: editCard
                }, " Редактировать "),
                (_ctx.type === 'active' && activeDays.value < 30)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "announcement-card__popup-menu-item",
                      onClick: prolongAd
                    }, " Продлить "))
                  : _createCommentVNode("", true),
                (_ctx.type === 'active')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "announcement-card__popup-menu-item",
                      onClick: addToArchive
                    }, " Архивировать "))
                  : _createCommentVNode("", true),
                (_ctx.type === 'archive')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "announcement-card__popup-menu-item",
                      onClick: removeFromArchive
                    }, " Восстановить "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "announcement-card__popup-menu-item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteCategoryModal(_ctx.card.id)))
                }, " Удалить ")
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_unref(DeleteDeveloperModal), {
        "delete-category-modal-data": deleteCategoryModalData.value,
        onClose: closeDeleteCategoryModal,
        onDeleteCategory: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deleteCategory', $event)))
      }, null, 8, ["delete-category-modal-data"]),
      (!!successMessage.value)
        ? (_openBlock(), _createBlock(_component_base_info_modal, {
            key: 0,
            "show-info-modal": !!successMessage.value,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (successMessage.value = undefined))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(successMessage.value), 1)
            ]),
            _: 1
          }, 8, ["show-info-modal"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})